import { Link } from '@inertiajs/react'
import { MarketingLayout } from '@/layouts/MarketingLayout'
import { Button } from '@/components/ui/button'
import { BookOpen } from 'lucide-react'

interface Props {
  slug: string
}

export default function NotFound({ slug }: Props) {
  return (
    <MarketingLayout appUrl="">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 pt-28 pb-24 lg:pt-36 text-center">
        <BookOpen className="h-16 w-16 mx-auto mb-6 text-muted-foreground opacity-50" />
        <h1 className="text-3xl font-bold text-foreground mb-4">Artículo no encontrado</h1>
        <p className="text-muted-foreground mb-8">
          No encontramos el artículo "{slug}".
        </p>
        <Button asChild>
          <Link href="/blog">Volver al blog</Link>
        </Button>
      </div>
    </MarketingLayout>
  )
}
